import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 10px;
  margin-bottom: 0;
  ${props =>
    props.marginBottom &&
    `margin-bottom: 10px;
  `}
  ${props =>
    props.withMarginTop &&
    `margin-top: 25px;
  `}
`;
export default Container;
